import Box from '@mui/material/Box';

const ProcessSteps = ({ steps }) => {
	if (!steps || steps.length === 0) return null;

	return (
		<Box className="process-container" component="ol">
			{steps.map((step, index) => (
				<Box key={index} className="process-step" component="li">
					<Box className="process-number" aria-hidden="true">
						<div>{String(index + 1).padStart(2, '0')}</div>
						<span></span>
					</Box>
					<Box className="process-details">
						<h3>{step.Title}</h3>
						<p>{step.Description}</p>
					</Box>
				</Box>
			))}
		</Box>
	);
};

export default ProcessSteps;
